import { useMemo } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { travelExpenseTypeList } from '@/module/Travel/Request/model/TravelRequestTypes';

import { EnumSelectControl, EnumSelectControlProps } from '@/core/components';

export type TravelExpenseTypeSelectControlProps<T extends FieldValues> = Omit<EnumSelectControlProps<T>, 'options'>;

// The mobility support line is toggled from its own card, never picked as an expense type.
export function TravelExpenseTypeSelectControl<T extends FieldValues>(props: TravelExpenseTypeSelectControlProps<T>) {
  const { t } = useTranslation();
  const options = useMemo(
    () =>
      travelExpenseTypeList
        .filter(value => value !== 'UMFST_MOBILITY_SUPPORT')
        .map(value => ({ value, label: t(`travel.expenseTypeEnum.${value}`) })),
    [t],
  );

  return (
    <EnumSelectControl
      {...props}
      options={options}
    />
  );
}
